/**
 * Default state for Vuex
 */
import { languages } from "../utils/language";
import nl from "../data/nl";
import fr from "../data/fr";
import en from "../data/en";

const state = {
    languages: languages.map(lang => {
        return {
            ...lang,
            active: (document.documentElement.lang === lang.code)
        }
    }),
    showLanguageMenu: true,
    i18n: {
        nl,
        fr,
        en
    },
    viewport: {
        height: document.body.scrollHeight - window.innerHeight || 1,
        scrolled: window.scrollY,
        visible: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
    }
}

export default state;